'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _Overlay = require('react-bootstrap/lib/Overlay');

var _Overlay2 = _interopRequireDefault(_Overlay);

var _Popover = require('react-bootstrap/lib/Popover');

var _Popover2 = _interopRequireDefault(_Popover);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propsComparer = require('../../utils/propsComparer');

var _propsComparer2 = _interopRequireDefault(_propsComparer);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _noop = require('../../utils/noop');

var _noop2 = _interopRequireDefault(_noop);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DropDownMenu = require('./DropDownMenu.scss');

var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DropDownMenu = (_temp = _class = function (_Component) {
    (0, _inherits3.default)(DropDownMenu, _Component);

    function DropDownMenu(props, context) {
        (0, _classCallCheck3.default)(this, DropDownMenu);

        var _this = (0, _possibleConstructorReturn3.default)(this, (DropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropDownMenu)).call(this, props, context));

        _this.open = function () {
            _this.setState({ show: true });
        };

        _this.close = function () {
            _this.setState({ show: false });
        };

        _this.toggle = function () {
            _this.setState({ show: !_this.state.show });
        };

        _this.attachOnClickListener = function (links) {
            // attach a listener that will close the menu on click
            return links.map(function (link) {
                var onClick = void 0;
                if (link.props.onClick) {
                    onClick = function onClick(event) {
                        link.props.onClick(event);
                        if (link.type !== 'form') {
                            _this.close();
                        }
                    };
                } else {
                    onClick = _this.close;
                }
                return _react2.default.cloneElement(link, { onClick: onClick });
            });
        };

        _this.state = { show: false };
        return _this;
    }

    (0, _createClass3.default)(DropDownMenu, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return (0, _propsComparer2.default)(this.props, nextProps, ['dropdownClass', 'links', 'mobile', 'parent', 'placement', 'popoverClass', 'title', 'titleClass']) || (0, _propsComparer2.default)(this.state, nextState, ['show']);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                dropdownClass = _props.dropdownClass,
                links = _props.links,
                mobile = _props.mobile,
                onEnter = _props.onEnter,
                onEntered = _props.onEntered,
                onExit = _props.onExit,
                onExited = _props.onExited,
                parent = _props.parent,
                placement = _props.placement,
                popoverClass = _props.popoverClass,
                title = _props.title,
                titleClass = _props.titleClass;


            var dropDownClassNames = (0, _classnames2.default)(_DropDownMenu2.default['dropdown-menu'], dropdownClass);
            var popOverClassNames = (0, _classnames2.default)(_DropDownMenu2.default.popover, popoverClass);
            var titleClassNames = (0, _classnames2.default)(_DropDownMenu2.default.title, titleClass);

            return (0, _jsx3.default)('div', {
                className: dropDownClassNames
            }, void 0, _react2.default.createElement(
                'a',
                {
                    ref: function ref(_ref) {
                        return _this2.targetRef = _ref;
                    },
                    onMouseEnter: !mobile ? this.open : _noop2.default,
                    onClick: this.toggle,
                    onMouseLeave: this.close
                },
                (0, _jsx3.default)('span', {
                    className: titleClassNames
                }, void 0, title, (0, _jsx3.default)(_reactFontawesome2.default, {
                    icon: this.state.show ? ['fas', 'caret-up'] : ['fas', 'caret-down'],
                    className: _DropDownMenu2.default.triangle
                }))
            ), (0, _jsx3.default)(_Overlay2.default, {
                show: this.state.show,
                onHide: this.close,
                placement: placement,
                target: this.targetRef,
                container: parent,
                onEnter: onEnter,
                onEntered: onEntered,
                onExit: onExit,
                onExited: onExited,
                rootClose: true
            }, void 0, (0, _jsx3.default)(_Popover2.default, {
                className: popOverClassNames,
                id: 'popover-trigger-click-root-close',
                onMouseOver: this.open,
                onMouseOut: this.close
            }, void 0, (0, _jsx3.default)('div', {
                className: _DropDownMenu2.default['dropdown-pop-up']
            }, void 0, this.attachOnClickListener(links)))));
        }
    }]);
    return DropDownMenu;
}(_react.Component), _class.defaultProps = {
    onEnter: _noop2.default,
    onEntered: _noop2.default,
    onExit: _noop2.default,
    onExited: _noop2.default
}, _temp);
exports.default = DropDownMenu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DropDownMenu/DropDownMenu.js
// module id = r3q8
// module chunks = 57